export class User {
  email: string;
  guid: string;
  language: string;
  isSSO: boolean;
  firstName: string;
  lastName: string;
  title: string;
  workPhone: string;
  mobilePhone: string;
  companyName: string;
  department: string;
  street1: string;
  street2: string;
  country: string;
  state: string;
  city: string;
  zip: string;


  constructor() {
    this.email = 'test@mtest.dfsco.com';
    this.guid = 'A54E7217-E1FD-4EA0-B88F-755BDA6D8137';
    this.language = 'ru';
    this.isSSO = false;
  }
}
